import {Card, CardProps, Stack, StackProps, styled} from '@mui/material';

const CardContainerStyle = styled(Card)<CardProps>(({theme}) => ({
	borderRadius: '8px',
	backgroundColor: theme.brand.primary.white,
	boxShadow: 'none',
}));

const CardContentStyle = styled(Stack)<StackProps>(() => ({
	padding: '16px',
}));

const CardFooterStyle = styled(Stack)<StackProps>(({theme}) => ({
	padding: '16px',
	backgroundColor: theme.colors.light.info['12Percent'],
}));

export {CardContainerStyle, CardContentStyle, CardFooterStyle};
